"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const journeySteps = [{
  numeral: "1",
  title: "Harvest",
  description: "Plucked at the peak of morning dew, our blooms begin their journey from earth to hand, ensuring maximum vitality.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_harvest_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_harvest_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_harvest_detail.png-wvc-sizes",
    alt: "Close up of hands carefully pruning a fresh flower in the garden"
  }
}, {
  numeral: "2",
  title: "Design",
  description: "Artfully arranged with an eye for wild symmetry, each stem finds its perfect place in our bespoke compositions.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_design_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_design_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_design_detail.png-wvc-sizes",
    alt: "Floral designer arranging stems with precision shears"
  }
}, {
  numeral: "3",
  title: "Deliver",
  description: "Wrapped in sustainable care, a piece of our serene garden arrives to breathe natural life into your chosen space.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_deliver_detail.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_deliver_detail.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675409/img/journey_deliver_detail.png-wvc-sizes",
    alt: "Hands tying a delicate ribbon around a finished bouquet"
  }
}];
export default function TheGardenToVaseJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-garden-to-vase-journey" className="relative py-24 md:py-32 bg-background overflow-hidden" ref={ref}>
      <div className="container mx-auto px-6 max-w-6xl">
        <div className={cn("text-center mb-20 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="text-4xl md:text-5xl font-serif text-foreground mb-6 tracking-tight">
            The Garden-to-Vase Journey
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-sans">
            Experience the meticulous care and artistry that goes into every PETAL arrangement, from our soil to your sanctuary.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-28 left-[10%] right-[10%] h-px bg-secondary-foreground/15 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8">
            {journeySteps.map((step, index) => <div key={step.numeral} data-index={index} className={cn("relative flex flex-col items-center text-center group transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${index * 200}ms`
          }}>
                {}
                <div className="absolute -top-12 md:-top-16 left-1/2 -translate-x-1/2 text-[10rem] md:text-[14rem] font-serif text-primary/5 leading-none select-none z-0 pointer-events-none transition-transform duration-700 group-hover:scale-105">
                  {step.numeral}
                </div>

                {}
                <div className="relative z-10 w-56 h-56 md:w-48 md:h-48 lg:w-56 lg:h-56 mb-8 p-2 bg-background rounded-3xl shadow-sm transition-transform duration-500 group-hover:-translate-y-2">
                  <img src={step.image.src} data-wvc-srcset={step.image.srcset} data-wvc-sizes={step.image.sizes} alt={step.image.alt} loading="lazy" className="w-full h-full object-cover rounded-2xl shadow-md" />
                </div>

                {}
                <div className="relative z-10 max-w-xs">
                  <h3 className="text-2xl font-serif text-foreground mb-4">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground font-sans leading-relaxed text-sm md:text-base">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className={cn("mt-20 text-center transition-all duration-1000 delay-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <Button asChild variant="outline" size="lg" className="rounded-xl font-serif text-lg px-8">
            <Link to="/TheGardenPage">
              Explore Our Garden
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}